import mutations from './mutations.js'
import actions from './actions.js'
import getters from './getters.js'

export default {
    //namespaced:true,
    state() {
        return{
            currentUser: {},
            testUser: {
                uid:'나와라UID',
                nic:'나와라NIC'
            },
            token: null,
            didAutoLogout: false,
            userIP:'',
            leftLoginTime:'',            
        }
    },
    mutations,
    actions,
    getters,

}
